const {
    _reportBalanceIncrease, 
    _reportBalance,
    _registerValidatorInitials, 
    _registerValidator, 
    _createStakehouse, 
    _joinStakehouse, 
    _addKnotToOpenIndexAndWithdraw, 
    _batchAddKnotToOpenIndexAndWithdraw,
    _batchTransferKnotsToSingleIndex,
    _BLSAuthentication,
    _batchBLSAuthentication,
    _rageQuitKnot,
    _rageQuit,
    _depositIntoSavETHRegistry,
    _depositAndIsolateKnotIntoIndex,
    _slash,
    _slashAndTopUpSlot,
    _createIndex,
    _approveTransferOfIndexOwnership,
    _transferIndexOwnership,
    _transferKnotToAnotherIndex,
    _approveSpendingOfKnotInIndex,
    _joinStakeHouseAndCreateBrand,
    _authorizeRepresentative,
    _isRepresentativeAuthorized,
    _deposit
} = require('../logic/index');

class IndexSubPackage {

    constructor(signer) {
        this.etherSigner = signer;
    }
    
    reportBalanceIncrease(stakehouseAddress, authenticatedReport) {
        return _reportBalanceIncrease(this.etherSigner, stakehouseAddress, authenticatedReport);
    }

    reportBalance(beaconNodeURL, blsPublicKey, stakehouseAddress) {
        return _reportBalance(this.etherSigner, beaconNodeURL, blsPublicKey, stakehouseAddress);
    }

    registerValidatorInitials(userAddress, blsPublicKey, blsSignature) {
        return _registerValidatorInitials(this.etherSigner, userAddress, blsPublicKey, blsSignature);
    }

    registerValidator(userAddress, authenticationPackage) {
        return _registerValidator(this.etherSigner, userAddress, authenticationPackage);
    }

    createStakehouse(userAddress, ticker, savETHIndexId, authenticatedReport) {
        return _createStakehouse(this.etherSigner, userAddress, ticker, savETHIndexId, authenticatedReport);
    }

    joinStakehouse(userAddress, stakehouseAddress, brandTokenId, savETHIndexId, authenticatedReport) {
        return _joinStakehouse(this.etherSigner, userAddress, stakehouseAddress, brandTokenId, savETHIndexId, authenticatedReport);
    }

    addKnotToOpenIndexAndWithdraw(stakehouseAddress, memberID, recipientAddress) {
        return _addKnotToOpenIndexAndWithdraw(this.etherSigner, stakehouseAddress, memberID, recipientAddress);
    }

    batchAddKnotToOpenIndexAndWithdraw(stakehouses, memberIDs, recipient) {
        return _batchAddKnotToOpenIndexAndWithdraw(this.etherSigner, stakehouses, memberIDs, recipient);
    }

    batchTransferKnotsToSingleIndex(stakehouses, memberIDs, targetSavETHIndexID) {
        return _batchTransferKnotsToSingleIndex(this.etherSigner, stakehouses, memberIDs, targetSavETHIndexID);
    }

    BLSAuthentication(keystorePassword, keystore, depositData, depositorSignaturePayload) {
        return _BLSAuthentication(this.etherSigner, keystorePassword, keystore, depositData, depositorSignaturePayload);
    }

    batchBLSAuthentication(keystorePassword, keystores, depositData, depositorSignaturePayload) {
        return _batchBLSAuthentication(this.etherSigner, keystorePassword, keystores, depositData, depositorSignaturePayload);
    }

    rageQuitKnot(stakehouseAddress, authenticatedReport, topUpAmountInWei) {
        return _rageQuitKnot(this.etherSigner, stakehouseAddress, authenticatedReport, topUpAmountInWei);
    }

    rageQuit(stakehouseAddress, userAddress, authenticatedReport) {
        return _rageQuit(this.etherSigner, stakehouseAddress, userAddress, authenticatedReport);
    }

    depositIntoSavETHRegistry(savETHRecipient, amount) {
        return _depositIntoSavETHRegistry(this.etherSigner, savETHRecipient, amount);
    }

    depositAndIsolateKnotIntoIndex(stakehouseAddress, blsPublicKey, indexID) {
        return _depositAndIsolateKnotIntoIndex(this.etherSigner, stakehouseAddress, blsPublicKey, indexID);
    }

    slash(stakehouseAddress, authenticatedReport) {
        return _slash(this.etherSigner, stakehouseAddress, authenticatedReport);
    }

    slashAndTopUpSlot(stakehouseAddress, slasherAddress, buyAmount, ethValue, authenticatedReport) {
        return _slashAndTopUpSlot(this.etherSigner, stakehouseAddress, slasherAddress, buyAmount, ethValue, authenticatedReport);
    }

    createIndex(ownerAddress) {
        return _createIndex(this.etherSigner, ownerAddress);
    }

    approveTransferOfIndexOwnership(indexID, spender) {
        return _approveTransferOfIndexOwnership(this.etherSigner, indexID, spender);
    }

    transferIndexOwnership(indexID, recipient) {
        return _transferIndexOwnership(this.etherSigner, indexID, recipient);
    }

    transferKnotToAnotherIndex(stakehouseAddress, blsPublicKey, newIndexID) {
        return _transferKnotToAnotherIndex(this.etherSigner, stakehouseAddress, blsPublicKey, newIndexID);
    }

    approveSpendingOfKnotInIndex(stakehouseAddress, blsPublicKey, spender) {
        return _approveSpendingOfKnotInIndex(this.etherSigner, stakehouseAddress, blsPublicKey, spender);
    }

    joinStakeHouseAndCreateBrand(userAddress, brandTicker, stakehouseAddress, savETHIndexId, authenticatedReport) {
        return _joinStakeHouseAndCreateBrand(this.etherSigner, userAddress, brandTicker, stakehouseAddress, savETHIndexId, authenticatedReport);
    }

    authorizeRepresentative(representative, enable) {
        return _authorizeRepresentative(this.etherSigner, representative, enable);
    }

    isRepresentativeAuthorized(representative, representee) {
        return _isRepresentativeAuthorized(this.etherSigner, representative, representee);
    }

    deposit(keystore, keystorePassword, depositData, privateKey=null, user=null) {
        return _deposit(this.etherSigner, keystore, keystorePassword, depositData, privateKey, user);
    }
}

module.exports = {
    IndexSubPackage
};
